import { NEARBY_SHOP_RADIUS_KM } from './geo';

/** Map public garage discovery API row → NearbyGarageCard workshop shape. */
export function mapDiscoveryGarageToWorkshop(g) {
  return {
    id: g.id || g._id,
    name: g.displayName || g.name || 'Workshop',
    location: g.location || '',
    city: g.city || '',
    services: Array.isArray(g.services) ? g.services : [],
    bestDeal: g.bestDeal || null,
    stats: g.stats || null,
    lat: g.latitude ?? g.lat ?? null,
    lng: g.longitude ?? g.lng ?? null,
    distance: g.distanceKm ?? null,
    rating: g.rating ?? null,
    tier: g.tier || null,
    garageTier: g.garageTier || null,
    nextSlot: g.nextSlot || null,
    matchReason: g.matchReason || null,
    matchedClusterId: g.matchedClusterId ?? null,
    selectedClusters: Array.isArray(g.selectedClusters) ? g.selectedClusters : [],
    clusterVerificationStatus: g.clusterVerificationStatus || null,
    fulfillmentFlags: g.fulfillmentFlags || {},
    fulfillmentScore: g.fulfillmentScore ?? 0,
  };
}

/** Keep garages without coords; drop those beyond radius when distance is known. */
export function filterWorkshopsWithinRadius(
  workshops,
  radiusKm = NEARBY_SHOP_RADIUS_KM
) {
  return workshops.filter(
    (w) => w.distance == null || w.distance <= radiusKm
  );
}
